import { render, staticRenderFns } from "./delete course.vue?vue&type=template&id=5627d6a0"
import script from "./delete course.vue?vue&type=script&lang=js"
export * from "./delete course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports